export interface MenuItem {
  title: string;
  link: string;
  icon?: string;
}

export const SidebarMenuItems: MenuItem[] = [
  {
    title: 'Dashboard',
    link: '/dashboard',
    icon: 'dashboard',
  },
  {
    title: 'Users',
    link: '/users',
    icon: 'group',
  },
  {
    title: 'Waitlist',
    link: '/waitlist',
    icon: 'share',
  },
  {
    title: 'Invites',
    link: '/invites',
    icon: 'share',
  },
  {
    title: 'Elements',
    link: '/elements',
    icon: 'hive',
  },
  {
    title: 'Clusters',
    link: '/clusters',
    icon: 'workspaces',
  },
  {
    title: 'Explore Section',
    link: '/explore',
    icon: 'explore',
  },
  {
    title: 'Onboarding Elements',
    link: '/onboarding',
    icon: 'format_list_bulleted',
  },
  {
    title: 'IP Blacklist',
    link: '/ip-blacklist',
    icon: 'playlist_remove',
  },
  {
    title: 'Block Username',
    link: '/block-username',
    icon: 'block',
  },
];
